export const EXPERTISE = [
  "Juridisch",
  "Beleid",
  "HR",
  "Finance",
  "ICT",
  "Projectmanagement",
  "Communicatie",
  "Inkoop/Aanbesteding",
  "Ruimtelijke Ordening",
  "Sociale Zaken",
  "Anders",
];

export const CONTRACT_TYPES = ["Detacheren/dienstverband", "ZZP", "Beide"];

export const ORG_TYPES = [
  "Gemeente",
  "Provincie",
  "Rijksoverheid",
  "Waterschap",
  "ZBO",
  "Anders",
];

export const PROVINCES = [
  "Noord-Holland",
  "Zuid-Holland",
  "Utrecht",
  "Noord-Brabant",
  "Gelderland",
  "Overijssel",
  "Friesland",
  "Groningen",
  "Drenthe",
  "Flevoland",
  "Zeeland",
  "Limburg",
];

export const APPLICATION_STATUS_LABELS = {
  ingediend: "In behandeling",
  aangeboden: "Aangeboden",
  aangenomen: "Aangenomen",
  afgewezen: "Afgewezen",
};

export const PROPOSAL_STATUS_LABELS = {
  verstuurd: "Verstuurd",
  interessant: "Interessant",
  niet_passend: "Niet passend",
};
